// Home.js
import React from 'react';
import HomePage from './HomePage';

const Home = () => {
  return (
    <div>
    
      <div href="#Home" style={{ textDecoration: 'none' }}><HomePage / ></div>
    </div>
  );
};

export default Home;
